import { render } from "./ItemsPage.vue?vue&type=template&id=e87c84ae"
import script from "./ItemsPage.vue?vue&type=script&lang=js"
export * from "./ItemsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__